import { API_BASE_URL, API_UPDATE_CLASS } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


export type ResultDetail = {
    [key: string]: boolean[]; // Keys like "hard-heard", "cat-cut", etc., and their boolean arrays
};

export type classInfo = {
    currentClass: string,
    newClass: string,
};

export type getUpdateClassReponse = {
    status: string,
    message: string
};


async function executeGetUpdateClassWithToken(accessToken: string | null, classInfo: classInfo): Promise<getUpdateClassReponse> {
    return axios
        .post(
            API_BASE_URL + API_UPDATE_CLASS,
            {
                currentClass: classInfo.currentClass,
                newClass: classInfo.newClass,
            },
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            throw new Error("Unexpected response status or missing data");
        })
        .catch(error => {
            if (error.response && error.response.status === 400) {
                console.log("Missing required fields");
            } else if (error.response && error.response.status === 403) {
                console.log("Missing required role");
            } else if (error.response && error.response.status === 404) {
                console.log("Param(s) not exist.");
            } else {
                console.error('Error during creation:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteGetUpdateClassWithToken(accessToken: string | null, classInfo: classInfo): Promise<getUpdateClassReponse> {

    return executeGetUpdateClassWithToken(accessToken, classInfo)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetUpdateClassWithToken(accessToken, classInfo);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
